<lib-base-signal-input
  [label]="label()"
  [showRequired]="showRequiredIndicator()"
  [showError]="showError()"
  [errorMessage]="errorMessage()"
  [disabled]="disabled()"
  [showExternalLabel]="true"
>
  <div input class="w-full py-2">
    @if (helpText()) {
      <p class="mb-3 text-xs text-slate-500">{{ helpText() }}</p>
    }
    @if (useStars()) {
      <div
        class="flex items-center gap-2"
        (mouseleave)="onStarLeave()"
        role="radiogroup"
        [attr.aria-label]="label() || 'Rating'"
      >
        @for (star of scaleValues(); track star) {
          <button
            type="button"
            class="cursor-pointer p-0.5 transition-colors duration-150 disabled:cursor-not-allowed disabled:opacity-60"
            [disabled]="disabled() || readonly()"
            [attr.aria-label]="'Rate ' + star + ' out of ' + scaleMax()"
            [attr.aria-checked]="value() === star"
            role="radio"
            (click)="select(star)"
            (mouseenter)="onStarHover(star)"
            (focus)="onStarHover(star)"
            (blur)="onStarLeave()"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              class="h-8 w-8"
              [class.text-amber-400]="isStarActive(star)"
              [class.text-slate-400]="!isStarActive(star)"
              aria-hidden="true"
            >
              <path
                [attr.fill]="isStarActive(star) ? 'currentColor' : 'none'"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linejoin="round"
                d="M12 2.5l2.9 5.88 6.49.94-4.7 4.58 1.11 6.47L12 17.27 6.2 20.37l1.11-6.47-4.7-4.58 6.49-.94L12 2.5z"
              />
            </svg>
          </button>
        }
      </div>
    } @else {
      <div class="w-full space-y-2">
        @if (showEndpointLabels()) {
          <div class="flex justify-between gap-2 text-sm text-gray-500">
            <span>{{ lowLabel() }}</span>
            <span class="text-right">{{ highLabel() }}</span>
          </div>
        }

        <div
          class="flex w-full overflow-hidden rounded-lg border border-gray-300"
          role="radiogroup"
          [attr.aria-label]="label() || 'Rating'"
        >
          @for (option of scaleValues(); track option; let last = $last) {
            <button
              type="button"
              class="flex-1 cursor-pointer px-1 py-3 text-center text-sm font-medium transition-colors duration-150 disabled:cursor-not-allowed disabled:opacity-60"
              [class.border-r]="!last"
              [class.border-gray-300]="!last"
              [class.bg-blue-500]="isButtonSelected(option)"
              [class.text-white]="isButtonSelected(option)"
              [class.bg-white]="!isButtonSelected(option)"
              [class.text-gray-900]="!isButtonSelected(option)"
              [class.hover:bg-blue-50]="!isButtonSelected(option) && !disabled() && !readonly()"
              [disabled]="disabled() || readonly()"
              [attr.aria-label]="'Rate ' + option"
              [attr.aria-checked]="isButtonSelected(option)"
              role="radio"
              (click)="select(option)"
            >
              {{ option }}
            </button>
          }
        </div>
      </div>
    }
  </div>
</lib-base-signal-input>
